import Route from '@core/components/Route';
import { RoutePath } from '@core/types/route';

import { InstructorTemplateProps } from '../../types/instructor-template';

export const DIMITRI_ERMISCH_CV: InstructorTemplateProps = {
  cv: [
    'geboren 1985 in Gornjak (Russland)',
    '2002 - 2011 Kun-Tai-Ko, Karate und Kickboxen (Shihan Adi Bernard)',
    '2006 Deutscher Vize Meister der World Kickboxing & Karate Association (WKA)',
    '2012 - 2012 Muay Thai Boran Puria Gym',
    '2012 - 2014 Auf der Suche nach der wahren Kampfkunst',
    '2015 - 2018 Escrima Club Trier (Martin Olk)',
  ],
  img: {
    alt: 'Dimitri Ermisch, Mit-Gründer und Ausbilder von Systema Akademie Trier',
    src: '/img/profile-dimitri-ermisch-250.jpg',
  },
  name: 'Dimitri Ermisch',
  school: {
    name: 'Systema Akademie Trier',
    url: 'https://www.systema-trier.de',
  },
  systema: [
    <>
      seit 2018 <Route href={RoutePath.SolovevStyle}>Solovev Defense</Route> (
      <Route href={RoutePath.FalkoZander}>Falko Zander</Route>)
    </>,
    <>
      seit 2018 <Route href={RoutePath.KampkunstPu}>Privatschüler</Route> von Falko Zander
    </>,
    <>Mit-Gründer, Systema Akademie Trier</>,
    <>
      <Route href={RoutePath.KampfkunstInstructorProgram}>Instructor</Route>, Solovev Defense
    </>,
    <>
      <Route href={RoutePath.KampfkunstRanking}>7. Schülergrad</Route>, Solovev Defense
    </>,
  ],
  vision:
    '"Kampfkunst und der Weg der Meisterschaft ist meine Leidenschaft. Es bereitet mir Freude zu forschen und mein Wissen mit anderen zu teilen."',
};
